import { render, staticRenderFns } from "./SettingsStatuses.vue?vue&type=template&id=4383a84a&scoped=true"
import script from "./SettingsStatuses.vue?vue&type=script&lang=js"
export * from "./SettingsStatuses.vue?vue&type=script&lang=js"
import style0 from "./SettingsStatuses.vue?vue&type=style&index=0&id=4383a84a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4383a84a",
  null
  
)

export default component.exports